import { ITEM } from "../../../utils/ServiceUtils";
import { ServiceBase } from "../ServiceBase";
import { ICreateActivityItemRequest } from "./requests/CreateActivityItemRequest";
import { ICreateProjectItemRequest } from "./requests/CreateProjectItemRequest";
import { IDeleteProjectItemRequest } from "./requests/DeleteProjectItemRequest";
import { IGetItemRequest } from "./requests/GetItemRequest";
import { IListItemPriceListsRequest } from "./requests/ListItemPriceListsRequest";
import { IListItemRequest } from "./requests/ListItemRequest";
import { IListProjectItemCalculationRequest } from "./requests/ListProjectItemCalculationRequest";
import { IListProjectItemRequest } from "./requests/ListProjectItemRequest";
import { IUpdateProjectItemRequest } from "./requests/UpdateProjectItemRequest";
import { CreateActivityItemResponse } from "./responses/CreateActivityItemResponse";
import { CreateProjectItemResponse } from "./responses/CreateProjectItemResponse";
import { DeleteProjectItemResponse } from "./responses/DeleteProjectItemResponse";
import { GetItemResponse } from "./responses/GetItemResponse";
import { ListItemPriceListsResponse } from "./responses/ListItemPriceListsResponse";
import { ListItemResponse } from "./responses/ListItemResponse";
import { ListProjectItemCalculationResponse } from "./responses/ListProjectItemCalculationResponse";
import { ListProjectItemResponse } from "./responses/ListProjectItemResponse";
import { UpdateProjectItemResponse } from "./responses/UpdateProjectItemResponse";
import { GetActivityItemResponse } from "./responses/GetActivityItemResponse";
import { IGetActivityItemRequest } from "./requests/GetActivityItemRequest";
import { IDeleteItemRequest } from "./requests/DeleteItemRequest";
import { DeleteItemResponse } from "./responses/DeleteItemResponse";
import { ListItemStatusResponse } from "./responses/ListItemStatusResponse";
import { IListItemStatusRequest } from "./requests/ListItemStatusRequest";
import { IListItemTypeRequest } from "./requests/ListItemTypeRequest";
import { ListItemTypeResponse } from "./responses/ListItemTypeResponse";
import { CreateItemResponse } from "./responses/CreateItemResponse";
import { ICreateItemRequest } from "./requests/CreateItemRequest";
import { IUpdateItemRequest } from "./requests/UpdateItemRequest";
import { UpdateItemResponse } from "./responses/UpdateItemResponse";
import { IListItemPricesRequest } from "./requests/ListItemPricesRequest";
import { ListItemPricesResponse } from "./responses/ListItemPricesResponse";
import { IListItemUnitRequest } from "./requests/ListItemUnitRequest";
import { ListItemUnitResponse } from "./responses/ListItemUnitResponse";
import { IListComponentCategoriesRequest } from "./requests/ListComponentCategoriesRequest";
import { ListComponentCategoriesResponse } from "./responses/ListComponentCategoriesResponse";
import { IGetCodebookRequest } from "./requests/GetCodebookRequest";
import { GetCodebookResponse } from "./responses/GetCodebookResponse";
import { IGetItemTypeRequest } from "./requests/GetItemTypeRequest";
import { GetItemTypeResponse } from "./responses/GetItemTypeResponse";
import { IModifyProjectItemValuesRequest } from "./requests/ModifyProjectItemValuesRequest";
import { ModifyProjectItemValuesResponse } from "./responses/ModifyProjectItemValuesResponse";
import { IUpdateProjectItemCalculationRequest } from "./requests/UpdateProjectItemCalculationRequest";
import { UpdateProjectItemCalculationResponse } from "./responses/UpdateProjectItemCalculationResponse";

export interface IItemService {
    listProjectItemCalculation(request: IListProjectItemCalculationRequest): Promise<ListProjectItemCalculationResponse>;
    listProjectItem(request: IListProjectItemRequest): Promise<ListProjectItemResponse>;
    listItem(request: IListItemRequest): Promise<ListItemResponse>;
    deleteProjectItem(request: IDeleteProjectItemRequest): Promise<DeleteProjectItemResponse>;
    createProjectItem(request: ICreateProjectItemRequest): Promise<CreateProjectItemResponse>;
    updateProjectItem(request: IUpdateProjectItemRequest): Promise<UpdateProjectItemResponse>;
    getItem(request: IGetItemRequest): Promise<GetItemResponse>;
    listItemPriceLists(request: IListItemPriceListsRequest): Promise<ListItemPriceListsResponse>;
    createActivityItem(request: ICreateActivityItemRequest): Promise<CreateActivityItemResponse>;
    getActivityItem(request: IGetActivityItemRequest): Promise<GetActivityItemResponse>;
    deleteItem(request: IDeleteItemRequest): Promise<DeleteItemResponse>;
    listItemStatus(request: IListItemStatusRequest): Promise<ListItemStatusResponse>;
    listItemType(request: IListItemTypeRequest): Promise<ListItemTypeResponse>;
    createItem(request: ICreateItemRequest): Promise<CreateItemResponse>;
    updateItem(request: IUpdateItemRequest): Promise<UpdateItemResponse>;
    listItemPrices(request: IListItemPricesRequest): Promise<ListItemPricesResponse>;
    listItemUnit(request: IListItemUnitRequest): Promise<ListItemUnitResponse>;
    listComponentCategories(request: IListComponentCategoriesRequest): Promise<ListComponentCategoriesResponse>;
    getCodebook(request: IGetCodebookRequest): Promise<GetCodebookResponse>;
    getItemType(request: IGetItemTypeRequest): Promise<GetItemTypeResponse>;
    modifyProjectItemValues(request: IModifyProjectItemValuesRequest): Promise<ModifyProjectItemValuesResponse>;
    updateProjectItemCalculation(request: IUpdateProjectItemCalculationRequest): Promise<UpdateProjectItemCalculationResponse>;
}

export class ItemService extends ServiceBase implements IItemService {
    private _addRootElementForItem(xml:string, call:string):string{
        xml = xml.replaceAll('</count><ITEM>', '</count><ROWS><ITEM>');
        xml = xml.replaceAll(`</ITEM></ns1:${call}>`, `</ITEM></ROWS></ns1:${call}>`);
        return xml;
    }
    public async listProjectItemCalculation(request: IListProjectItemCalculationRequest): Promise<ListProjectItemCalculationResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listProjectItemCalculation, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.listProjectItemCalculation, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listProjectItemCalculation, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).ListProjectItemCalculationResponse as ListProjectItemCalculationResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async listProjectItem(request: IListProjectItemRequest): Promise<ListProjectItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listProjectItem, request.cancelSource));
            response = this._addRootElementForItem(tmp_response.data, 'ListProjectItemResponse');
            await this.updateCache(ITEM.listProjectItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listProjectItem, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).ListProjectItemResponse as ListProjectItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async listItem(request: IListItemRequest): Promise<ListItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listItem, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(ITEM.listItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listItem, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['ITEM']).ListItemResponse as ListItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async deleteProjectItem(request: IDeleteProjectItemRequest): Promise<DeleteProjectItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.deleteProjectItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.deleteProjectItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.deleteProjectItem, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).DeleteProjectItemResponse as DeleteProjectItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async createProjectItem(request: ICreateProjectItemRequest): Promise<CreateProjectItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.createProjectItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.createProjectItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.createProjectItem, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CreateProjectItemResponse as CreateProjectItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async updateProjectItem(request: IUpdateProjectItemRequest): Promise<UpdateProjectItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.updateProjectItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.updateProjectItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.updateProjectItem, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).UpdateProjectItemResponse as UpdateProjectItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async getItem(request: IGetItemRequest): Promise<GetItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.getItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.getItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.getItem, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,
            [
                'CATEGORY', 
                'ROLE', 
                'PRICE_GROUP', 
                'SUBJECT_PRICE_GROUP', 
                'COMPONENT', 
                'EXTERNAL_ID',
                'SHARE'
            ]).GetItemResponse as GetItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listItemPriceLists(request: IListItemPriceListsRequest): Promise<ListItemPriceListsResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listItemPriceLists, request.cancelSource));
            response = this._addRootElementForItem(tmp_response.data, 'ListItemPriceListsResponse');
            await this.updateCache(ITEM.listItemPriceLists, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listItemPriceLists, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['priceList', 'itemPrice']).ListItemPriceListsResponse as ListItemPriceListsResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async createActivityItem(request: ICreateActivityItemRequest): Promise<CreateActivityItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.createActivityItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.createActivityItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.createActivityItem, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CreateActivityItemResponse as CreateActivityItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async getActivityItem(request: IGetActivityItemRequest): Promise<GetActivityItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.getActivityItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.getActivityItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.getActivityItem, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['ACTIVITY_ITEM']).GetActivityItemResponse as GetActivityItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
        }

    public async deleteItem(request: IDeleteItemRequest): Promise<DeleteItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.deleteItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.deleteItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.deleteItem, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).DeleteItemResponse as DeleteItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listItemStatus(request: IListItemStatusRequest): Promise<ListItemStatusResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listItemStatus, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.listItemStatus, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listItemStatus, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['ITEM_STATUS']).ListItemStatusResponse as ListItemStatusResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listItemType(request: IListItemTypeRequest): Promise<ListItemTypeResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listItemType, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.listItemType, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listItemType, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['ITEM_TYPE']).ListItemTypeResponse as ListItemTypeResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async createItem(request: ICreateItemRequest): Promise<CreateItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.createItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.createItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.createItem, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).CreateItemResponse as CreateItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async updateItem(request: IUpdateItemRequest): Promise<UpdateItemResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.updateItem, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.updateItem, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.updateItem, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).UpdateItemResponse as UpdateItemResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listItemPrices(request: IListItemPricesRequest): Promise<ListItemPricesResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listItemPrices, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.listItemPrices, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listItemPrices, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['ITEM_PRICE']).ListItemPricesResponse as ListItemPricesResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listItemUnit(request: IListItemUnitRequest): Promise<ListItemUnitResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listItemUnit, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.listItemUnit, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listItemUnit, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['ITEM_UNIT']).ListItemUnitResponse as ListItemUnitResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listComponentCategories(request: IListComponentCategoriesRequest): Promise<ListComponentCategoriesResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.listComponentCategories, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.listComponentCategories, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.listComponentCategories, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['COMPONENT_CATEGORY']).ListComponentCategoriesResponse as ListComponentCategoriesResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async getCodebook(request: IGetCodebookRequest): Promise<GetCodebookResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.getCodebook, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.getCodebook, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.getCodebook, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['CODEBOOK', 'VALUES']).GetCodebookResponse as GetCodebookResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async getItemType(request: IGetItemTypeRequest): Promise<GetItemTypeResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.getItemType, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.getItemType, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.getItemType, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['PROJECTTYPE']).GetItemTypeResponse as GetItemTypeResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async modifyProjectItemValues(request: IModifyProjectItemValuesRequest): Promise<ModifyProjectItemValuesResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.modifyProjectItemValues, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.modifyProjectItemValues, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.modifyProjectItemValues, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).ModifyProjectItemValuesResponse as ModifyProjectItemValuesResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async updateProjectItemCalculation(request: IUpdateProjectItemCalculationRequest): Promise<UpdateProjectItemCalculationResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), ITEM.updateProjectItemCalculation, request.cancelSource));
            response = (tmp_response.data);
            await this.updateCache(ITEM.updateProjectItemCalculation, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(ITEM.updateProjectItemCalculation, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).UpdateProjectItemCalculationResponse as UpdateProjectItemCalculationResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }
}
